var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPitchbook = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.224,
    d: "M13 25.125c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M16.423 6.375c-7.926.645-11.198 7.213-9.895 11.342.764-1.177 2.187-2.46 5.096-2.935-.169-3.479 1.09-5.906 4.799-8.407"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M12.362 15.28c-2.003.329-3.396.872-4.27 1.696.027 1.1.342 2.175.914 3.115.677-1.654 2.9-2.825 6.279-2.834-.822-3.965 1.015-7.598 3.871-10.036-1.414.21-2.799.58-4.128 1.106-2.175 2.096-2.985 4.798-2.667 6.954"
  })));
};
export default SvgPitchbook;